import { extend } from "vee-validate";
import {
  max,
  min,
  required,
} from "vee-validate/dist/rules";

extend("min", {
  ...min,
  message: "is min",
});
extend("max", {
  ...max,
  message: "is max",
});
extend("required", {
  ...required,
  message: "is required",
});
extend('only-letters', {
  validate: (value) => {
    return /^[A-Za-z ]+$/.test(value);
  },
  message: 'Only letters are allowed'
});

extend('only-letters-all', {
  validate: (value) => {
    return /^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/.test(value);
  },
  message: 'Only letters are allowed All'
});

extend('valid-expiration-date', {
  validate: (value) => {
    // Verificar que el valor tenga el formato MM/YY
    if (!/^\d{2}\/\d{2}$/.test(value)) {
      return false; // El formato no es válido
    }

    // Separar el valor en mes y año
    const [month, year] = value.split('/');

    // Validar que el mes y año sean válidos
    if (month < 1 || month > 12) {
      return false; // El mes debe estar entre 01 y 12
    }

    // Obtener el año actual y los dos últimos dígitos
    const currentYear = new Date().getFullYear().toString().substr(-2);
    const currentMonth = new Date().getMonth() + 1; // Los meses comienzan desde 0, por eso sumamos 1

    // Validar que el año no sea menor que el año actual
    if (year < currentYear) {
      return false; // El año debe ser mayor o igual al año actual
    }

    // Si el año es igual al actual, el mes debe ser mayor o igual al mes actual
    if (year == currentYear && month < currentMonth) {
      return false; // No se permiten fechas pasadas dentro del año actual
    }

    return true;
  },
  message: 'Invalid expiration date'
});

extend("is_numeric", {
  validate: (value) => /^[0-9]+$/.test(value),
  message: "Enter only numbers",
});

extend("email", {
  validate: (value) => {
    // Expresión regular para validar el formato de correo electrónico
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  },
  message: "Enter a valid email address",
});
